import { Inject, Injectable, PLATFORM_ID, inject } from '@angular/core';
import { IConfigParams, IConsentParams, IEventParams, IItem, TEventNames } from './google-analytics.interface';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  @Inject(PLATFORM_ID) private _platformId: any = inject(PLATFORM_ID);

  public gtag(
    command: 'event' | 'consent',
    event: TEventNames | IConfigParams | IConsentParams | (string & NonNullable<unknown>) | string,
    params?: IEventParams | IConsentParams | IItem,
  ): void {
    if (!isPlatformBrowser(this._platformId)) {
      return;
    }

    // Check to see if google analytics is loaded. Dev does not load it.
    if ((<any>window).gtag) {
      (<any>window).gtag(command, event, params);
    }
  }

  public event(event: TEventNames | IConfigParams | (string & NonNullable<unknown>), params?: IEventParams | IItem): void {
    if (!isPlatformBrowser(this._platformId)) {
      return;
    }

    if ((<any>window).gtag) {
      this.gtag('event', event, params);
    }
  }
}
